import React, { useEffect, useState } from 'react';
import SettingContainer from '../SettingContainer';
import { useConfig } from '../../../DataStore/ConfigContext';
import ActivityLoader from '../../Common/ActivityLoader';
import Notification from '../../Common/Notification';
import { useTheme } from '../../../DataStore/ThemeContext';

const ReportComment = () => {
    const { openSettings } = useTheme();
    const [activeRecord, setActiveRecord] = useState(null);
    const { getReportCommentConfig, reportCommentListing} = useConfig();

    useEffect(() => {
        getReportCommentConfig();
    }, []);

    const handleNew = () => {
        openSettings("Configure New Comment", "ConfigNewComment");
    };

    const handleEdit = () => {
        openSettings("Edit Report Comment", "ConfigEditComment", activeRecord);
        handleRefresh();
    };

   

    const handleRefresh = () => {
        //clear selection
        setActiveRecord(null);
        getReportCommentConfig(true);
    };

    const menu = () => (
        <>
            <button type="button" tabIndex="0" className="dropdown-item" onClick={handleNew}>
                <i className="dropdown-icon fa fa-plus-circle"></i>
                <span>Create New</span>
            </button>
            <button type="button" tabIndex="0" className="dropdown-item" disabled={!activeRecord} onClick={handleEdit}>
                <i className="dropdown-icon fa fa-edit text-primary"></i>
                <span>Edit Selection</span>
            </button>
            <button type="button" tabIndex="0" className="dropdown-item" onClick={handleRefresh}>
                <i className="dropdown-icon fa fa-sync text-primary"></i>
                <span>Refresh</span>
            </button>
        </>
    );

    return (
        <SettingContainer title="Report Comments" icon="fa fa-comment" Menu={menu}>
              <div className="align-middle mb-3 table table-borderless table-striped table-hover">
                       {Array.isArray(reportCommentListing) &&  <table className="table expandable-table table-striped text-nowrap mb-0">
                            <thead>
                                <tr>
                                <th>No.</th>                                   
                                <th>Comment title</th>
                                <th>Scope</th> 
                                <th>Tag</th> 
                            </tr>
                        </thead>
                        <tbody>
                            {reportCommentListing.map((item, key)=>
                                <tr 
                                    className={`${item.id === activeRecord?.id ? 'row-active' : ''}`}
                                    style={{cursor:'default'}}
                                    key={key}
                                    onClick={() => setActiveRecord(item)}
                                    >
                                    <td>{key+1}</td>
                                    <td>{item.title}</td>
                                    <td>{item.scope.comment_scope}</td>
                                    <td>{item.tag}</td>
                                   
                                </tr>
                            )}
            
                        </tbody>
                        </table>}
                        {!reportCommentListing && <ActivityLoader />}
                        {reportCommentListing === "404" && (
                            <Notification type="light" message="No report comments found." closable={false} />
                        )}
                    </div>
        </SettingContainer>
    );
};

export default ReportComment;
